import { get } from 'lodash'

class ApiMapperBiddingError {
  constructor(error = {}) {
    this.errorBody = get(error, 'body')
    // should handle both v1 and v2 (api-mapper) paths
    this.code =
      get(error, 'body.status.errors[0].code') ||
      error.body?.title ||
      get(this.errorBody, 'title') ||
      ''
    this.http_code =
      get(this.errorBody, 'status.code') ||
      get(this.errorBody, 'status') ||
      get(error, 'status') ||
      ''
  }

  get message() {
    return `Error in Bidding, Code: ${this.code}`
  }
}

export { ApiMapperBiddingError }
